import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=d6f2864e&scoped=true&"
var script = {}
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=d6f2864e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f2864e",
  null
  
)

export default component.exports